// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__23kx9","modalFooterButton":"ModalNotes_modalFooterButton__2jieJ"};